export const sortBySelection =  (dataArray,selectCompareStations) =>{
    let output = []
    let selectedArray = Object.entries(selectCompareStations)
    selectedArray.forEach(element =>{
        output.push(dataArray.find(item => item[0] === element[1].id))
    })
    return output
}